function cov_1xtv5t5ezl() {
  var path = "/app/src/components/logo/components/logo-en-black-on-transparent/index.ts";
  var hash = "cb4ce6048215507f7cd7b8b29ff1d084124aebf0";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/logo/components/logo-en-black-on-transparent/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "cb4ce6048215507f7cd7b8b29ff1d084124aebf0"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1xtv5t5ezl = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1xtv5t5ezl();
export { LogoEnBlackOnTransparent } from './logo-en-black-on-transparent';